module.exports = __webpack_public_path__ + "static/media/DefaultGroupCover.7ff391be.png";